import * as css from './AccountSwitcher.css';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {List} from '@tickchak/react-share/app';
import useShow from '../../../../../hooks/useShow';
import setGlobalState from '../../../../../redux/setGlobalState';
import {getAccounts} from '../../../../../redux/suggestions/suggestionsActions';
import {dispatchCustomEvent} from '../../../../../hooks/dispatchEvent';
import {packageImage} from '../../../../../assets/symbols/symbols/Symbols.css';

function AccountSwitcher({cardRef}: {cardRef: React.RefObject<HTMLDivElement>}) {
    const account = useSelector((s: any) => s.account);
    const accounts = useSelector((s: any) => s.suggestions.accounts) || [];
    const {t} = useTranslation('package');
    const navigate = useNavigate();
    const show = useShow();
    const [position, setPosition] = useState<any>({width: '375px', maxHeight: '400px'});

    const fetchAccounts = (search = '') => {
        setGlobalState('suggestions.accounts', []);
        getAccounts({search, limit: 20, offset: 0});
    };

    const open = (e) => {
        const card = cardRef.current;
        if(card) {
            const caret = e.currentTarget.getBoundingClientRect();
            const rect = card.getBoundingClientRect();
            setPosition({width: '375px', maxHeight: '400px',
                top: Math.round(caret.bottom - rect.top + 8),
                inlineStart: Math.round(rect.right - caret.right) + 'px'});
        }
        fetchAccounts();
        show.open();
    };

    const switchTo = (pid) => {
        dispatchCustomEvent('changePackage', {detail: pid});
        dispatchCustomEvent('changeEvent', {detail: null});
        navigate({pathname: '/p/' + pid + '/home'});
        show.close();
    };

    const items = accounts.map((a) => ({
        id: a.pid, text: a.title, subText: `${t('accountNumberShort')} ${a.pid}`,
        selected: a.pid === account.pid, selectionType: 'checkbox' as const,
        avatar: {src: a.image || packageImage, alt: a.title, size: 'lg' as const},
    }));

    return (
        <>
            <css.nameCaret onClick={open} data-cy="account-switcher-trigger"/>
            {show.isOpen &&
                <List show={show} position={position} data-cy="account-switcher"
                    onItemClick={(it) => switchTo(Number(it.id))}>
                    <List.Header title={t('switchAccount')}/>
                    <List.Search placeholder={t('searchAccount')} onSearch={fetchAccounts} autoFocus/>
                    <List.Items items={items}/>
                </List>}
        </>
    );
}

export default AccountSwitcher;
